import React from 'react';
import { Volume2Icon, ClockIcon } from 'lucide-react';
interface AudioPlayerProps {
  src: string;
  title?: string;
  subtitle?: string;
  durationLabel?: string;
}
export function AudioPlayer({
  src,
  title,
  subtitle,
  durationLabel
}: AudioPlayerProps) {
  return <div className="w-full" data-id="element-442">
      {title && <div className="text-center mb-6" data-id="element-443">
          <h3 className="font-display text-2xl md:text-3xl font-bold text-[#e8e6e1] mb-2" data-id="element-444">
            {title}
          </h3>
          {subtitle && <p className="text-[#9a9aab] text-sm md:text-base max-w-lg mx-auto" data-id="element-445">
              {subtitle}
            </p>}
        </div>}

      <div className="relative rounded-2xl bg-[#0a0e1a] border border-[#c9a84c]/25 p-5 md:p-6 shadow-[0_0_30px_rgba(201,168,76,0.08)]" data-id="element-446">
        {/* Subtle inner glow */}
        <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
        background: 'radial-gradient(ellipse at center, rgba(201,168,76,0.03) 0%, transparent 70%)'
      }} aria-hidden="true" data-id="element-447" />

        <div className="relative" data-id="element-448">
          {/* Label row */}
          <div className="flex items-center justify-between mb-4" data-id="element-449">
            <div className="flex items-center gap-2" data-id="element-450">
              <Volume2Icon className="w-4 h-4 text-[#c9a84c]" aria-hidden="true" data-id="element-451" />
              <span className="text-[#e8e6e1] text-sm font-semibold" data-id="element-452">
                Escuchar ahora
              </span>
            </div>
            {durationLabel && <div className="flex items-center gap-1.5" data-id="element-453">
                <ClockIcon className="w-3.5 h-3.5 text-[#c9a84c]" aria-hidden="true" data-id="element-454" />
                <span className="text-[#c9a84c] text-xs font-semibold tracking-wide" data-id="element-455">
                  {durationLabel}
                </span>
              </div>}
          </div>

          {/* Google Drive audio embed */}
          <div className="w-full rounded-xl overflow-hidden bg-[#1a1f36]" data-id="element-456">
            <iframe src={src} className="w-full" style={{
            height: '80px',
            border: 'none'
          }} allow="autoplay" title="Audio de reprogramación mental" data-id="element-457" />
          </div>
        </div>
      </div>
    </div>;
}